require('./cmFundsSummary.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
// @commons
const {
    OKBoxSectionContent,
} = require('commonsComponents/OKBoxSectionContent');
// @components
const { ContentSummary } = require('./content/contentSummary');
// @helpers
const { FormattedText } = require('core/i18n').i18n;

class CmFundsSummaryTable extends React.Component {
    render() {
        const {
            portfolio,
            showGeneralMinAmountMessage,
            isFetchingPortfolioInfo,
            reportCompleted,
        } = this.props;
        const assets = portfolio ? portfolio.get('assetClassInfo') : [];

        return (
            <OKBoxSectionContent
                hasShadow={false}
                hasBorder
                hasPadding={false}
                headerContentLeft={
                    <FormattedText value="brokerCM-fundsSummaryFundNameHeader" />
                }
                headerContentRight={
                    <FormattedText value="brokerCM-fundsSummaryLegalDocumentHeader" />
                }
                content={
                    <ContentSummary
                        assets={assets}
                        showGeneralMinAmountMessage={
                            showGeneralMinAmountMessage
                        }
                        isFetchingPortfolioInfo={isFetchingPortfolioInfo}
                        reportCompleted={reportCompleted}
                    />
                }
            />
        );
    }
}

CmFundsSummaryTable.propTypes = {
    isFundsLink: PropTypes.bool,
    portfolio: PropTypes.object,
    showGeneralMinAmountMessage: PropTypes.bool,
    isFetchingPortfolioInfo: PropTypes.bool,
    reportCompleted: PropTypes.func.isRequired,
};

module.exports = CmFundsSummaryTable;
